import React, { useEffect } from 'react'
import { useMediaQuery } from '@chakra-ui/react'

const useScrollToTheTop = (ref?: React.RefObject<HTMLDivElement | null> | null): void => {
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  useEffect(() => {
    if (isTabletOrMobile && ref?.current) ref?.current?.scrollIntoView({ behavior: 'smooth' })
    else window.scrollTo({ top: 0 })
  }, [])
}

export default useScrollToTheTop
